import state from './state'
import actions from './actions'
import mutations from './mutations'

export default {
  state,
  actions,
  mutations,
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/user/index.js